import { render } from "./Footer.vue?vue&type=template&id=084ddede&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=084ddede&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-084ddede"

export default script